import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import { WsButton, WsTypography, WsTypoVariants } from 'wisestep-base';

const AdvancedFiltersHeader = () => (
  <Stack direction="row" justifyContent="space-between" p={1} alignItems="center">
    <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
      Advanced Filters
    </WsTypography>
    <Box>
      <WsButton variant="contained" size="small" type="submit">
        Apply
      </WsButton>
      <Tooltip title="Reset" placement="top">
        <IconButton type="reset">
          <RestartAltOutlinedIcon color="error" />
        </IconButton>
      </Tooltip>
    </Box>
  </Stack>
);

export default AdvancedFiltersHeader;
